module.exports = __webpack_public_path__ + "img/button_kuang.c6246d5b.png";